export interface ICompany {
	name?: string;
	owner?: number;
	website?: string;
	phone?: string;
	otherPhone?: string;
	googlePlusHandle?: string;
	linkedInHandle?: string;
	facebookHandle?: string;
	linkedinHandle?: string;
	skypeId?: string;
	twitterHandle?: string;
	currency?: string;
	billingAddressLine1?: string;
	billingAddressLine2?: string;
	billingCity?: string;
	billingZipCode?: string;
	billingCountry?: string;
	billingState?: string;
	description?: string;
	tags?: string;
}
